import { Button } from "@mui/material";
import { styled } from "@mui/system";
import React from "react";
import { Link } from "react-scroll";

const MainContainer = styled("div")({
  display: "none",
  "@media (max-width: 650px)": {
    width: "100%",
    height: "600px",
    color: "black",
    backgroundColor: "white",
    boxSizing: "border-box",
    position: "relative",
    display: "flex",
    padding: "12px 24px",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    borderRadius: "7px",
    marginBottom: "1rem",
    textAlign: "left",
  },
});

const InfoContainer = styled("div")({
  backgroundColor: "white",
  height: "358px",
  textAlign: "left",
  marginBottom: "1rem",
});

const InfoHeader = styled("h1")({});

const InfoDescription = styled("p")({
  color: "#575757",
});

const StyledGif = styled("img")({
  width: "100%",
  maxWidth: "500px",
  borderRadius: "10px",
  boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
});

const StyledButton = styled(Button)({
  backgroundColor: "#000000",
  color: "white",
  textTransform: "unset",
  boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
  ":hover": {
    backgroundColor: "#000000",
  },
});

const MobileWorkflowBanner = () => {
  return (
    <MainContainer>
      <InfoContainer>
        <InfoHeader>{`The best workflows,\n all in one place`}</InfoHeader>
        <InfoDescription>
          Browse the Workflow86 templates library for best practice workflows
          that you can download, run and cutomize with just one click. All built
          in Worflow86 - the fastest way to document, automate and scale your
          internal business processes.
        </InfoDescription>
        <Link to="featuredTemplateMobile" smooth offset={-80}>
          <StyledButton>👇 BROWSE TEMPLATES</StyledButton>
        </Link>
      </InfoContainer>
      <StyledGif src="images/newb.gif" />
    </MainContainer>
  );
};

export default MobileWorkflowBanner;
